import HttpService from './baseHttp'

// 系统基础服务
export const HttpReset = (data = {}) => HttpService.post('/auth/jwt/requirePasswordReset', data, { baseURL: process.env.VUE_APP_APIURL_UC })
export const HttpResetByToken = (data = {}) => HttpService.post('/auth/jwt/resetPasswordWithToken', data, { baseURL: process.env.VUE_APP_APIURL_UC })

// 用户基础服务
export const HttpUpdateUserInfo = (data = {}) => HttpService.post('/api/v1/My/setUserProfile', data, { baseURL: process.env.VUE_APP_APIURL_UC })
export const HttpUpdatePassword = (data = {}) => HttpService.post('/api/v1/My/setUserNewPassword', data, { baseURL: process.env.VUE_APP_APIURL_UC })

//检查当前用户的密码是否为弱密码
export const HttpCheckPassweak = (data = {}) => HttpService.get('/api/v1/My/checkMyPasswordWeak', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
//检测是否为弱密码
export const HttpAuthPassweak = (data = {}) => HttpService.post('/auth/jwt/isPasswordWeak', data, { baseURL: process.env.VUE_APP_APIURL_UC })
//备选用户分页列表接口
export const HttpUserList = (data = {}) => HttpService.get('/api/v1/User/findByPageOrIds', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })

//切换用户
export const HttpSwitchUser = (data = {}) => HttpService.get('/auth/jwt/runas', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })

// 申请绑定
export const HttpChannelBind = (data = {}) => HttpService.post('/api/v1/My/requireChannelBind', data, { baseURL: process.env.VUE_APP_APIURL_UC })
// 绑定通道
export const HttpBind = (data = {}) => HttpService.post('/api/v1/My/bindChannelWithToken', data, { baseURL: process.env.VUE_APP_APIURL_UC })
// 登录、设定MFA发送验证码
export const HttpSendMFACode = (data = {}) => HttpService.post('/auth/jwt/requireOperateConfirm', data, { baseURL: process.env.VUE_APP_APIURL_UC })
// 设定MFA
export const HttpSetMFA = (data = {}) => HttpService.post('/api/v1/My/setMfaTypeWithToken', data, { baseURL: process.env.VUE_APP_APIURL_UC })
// 验证码登录
export const HttpVCodeLogin = (data = {}) => HttpService.post('/auth/jwt/authorizeViaCode', data, { baseURL: process.env.VUE_APP_APIURL_UC })
// 获取MFA密钥
export const HttpGetMFASecret = (data = {}) => HttpService.post('/api/v1/My/getSetMfaSecret', data, { baseURL: process.env.VUE_APP_APIURL_UC })
// 获取MFA密钥
export const HttpResetMFASecret = (data = {}) => HttpService.post('/api/v1/My/resetMfaSecret', data, { baseURL: process.env.VUE_APP_APIURL_UC })
// 解除绑定账户
export const HttpUnbind = (data = {}) => HttpService.post('/api/v1/My/unbindChannel', data, { baseURL: process.env.VUE_APP_APIURL_UC })

//全局-注册申请 检查属性标识是否存在
export const HttpCheckIdVectorExists = (data = {}) => HttpService.get('/global/registration/checkIdVectorExists', { params: data, baseURL: process.env.VUE_APP_APIURL_UC })
//提交注册申请
export const HttpRegistCommit = (data = {}) => HttpService.post('/global/registration/commit', data, { baseURL: process.env.VUE_APP_APIURL_UC })

// 检查密码安全性
export const HttpCheckPasswordSecurity = (data = {}) => HttpService.get("/api/v1/My/checkAccountSecurityPolicy", { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
